import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { TUser } from '../../utils/types/agrocraftArtisan';

const initialState: TUser | undefined = {};

export const authUserSlice = createSlice({
  name: 'authUserSlice',
  initialState,
  reducers: {
    updateAuthUser: (
      _state,
      action: PayloadAction<TUser>
    ) => ({ ...action.payload }),
    resetAuthUser: () => ({
      ...initialState,
    }),
  },
});

export const { updateAuthUser, resetAuthUser } =
  authUserSlice.actions;

export default authUserSlice.reducer;
